import { Clock, Mail, Frown, TrendingDown } from "lucide-react";

const PAINS = [
  {
    icon: Clock,
    title: "Le soir sur les devis",
    text: "Après une journée de chantier, vous rouvrez l'ordinateur pour rédiger des devis au lieu de vous reposer.",
  },
  {
    icon: Mail,
    title: "Les factures qui traînent",
    text: "Des clients qui n'ont pas payé depuis 2 mois et vous n'avez pas eu le temps de relancer.",
  },
  {
    icon: Frown,
    title: "L'administratif vous bouffe",
    text: "URSSAF, Kbis, attestations d'assurance… chaque courrier est une prise de tête.",
  },
  {
    icon: TrendingDown,
    title: "Des devis qui partent dans le vide",
    text: "Vous faites le déplacement, vous rédigez, et le client ne répond plus. Aucun suivi.",
  },
];

export default function Problem() {
  return (
    <section
      id="probleme"
      data-testid="problem-section"
      className="bg-[#F5F0EB] py-20 sm:py-28 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl reveal">
          <span className="inline-block text-[#E8611A] font-semibold text-sm tracking-widest uppercase mb-4">
            Le problème
          </span>
          <h2 className="font-display font-extrabold text-[#1A2E4A] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Vous êtes artisan,
            <br />
            <span className="text-[#E8611A]">pas comptable.</span>
          </h2>
          <p className="mt-6 text-[#2D2D2D]/80 text-base sm:text-lg leading-relaxed">
            Entre les devis à rédiger, les factures à envoyer, les clients qui
            ne paient pas et les papiers administratifs, vous passez des heures
            à faire un travail qui n&apos;est pas le vôtre — et qui vous éloigne de
            vos chantiers.
          </p>
        </div>

        <div className="mt-14 sm:mt-20">
          <h3 className="font-display font-bold text-[#1A2E4A] text-xl sm:text-2xl mb-8">
            Ça vous ressemble&nbsp;?
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            {PAINS.map(({ icon: Icon, title, text }, i) => (
              <article
                key={i}
                data-testid={`pain-card-${i}`}
                className="reveal group bg-white border border-black/5 rounded-sm p-6 sm:p-8 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="flex items-start gap-5">
                  <span className="shrink-0 inline-flex items-center justify-center w-12 h-12 rounded-sm bg-[#E8611A]/10 text-[#E8611A] group-hover:bg-[#E8611A] group-hover:text-white transition-colors">
                    <Icon className="w-6 h-6" strokeWidth={2.2} />
                  </span>
                  <div>
                    <h4 className="font-display font-bold text-[#1A2E4A] text-lg sm:text-xl">
                      {title}
                    </h4>
                    <p className="mt-2 text-[#2D2D2D]/75 text-sm sm:text-base leading-relaxed">
                      {text}
                    </p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
